import React from 'react';
import OrderDirectionsEnum from '../../../Enums/OrderDirectionsEnum';
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum';
import ButtonRow from '../../../Elements/ButtonRow';
import ApolloShopCopierSearchParams from './ApolloShopCopierSearchParams';
import GeneralSearchStrip from '../../../Elements/GeneralSearchStrip';
import ApolloShopCopierService from '../../../Services/ApolloShopCopierService';
import ApolloShopCopierHistoryItem from '../../../Domain/ApolloShopCopierHistoryItem';
import GeneralEditWizzardBase from '../../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import CrudTypesEnum from '../../../Enums/CrudTypesEnum';
import DuplicateShopItem from '../../../Domain/DuplicateShopItem';
import DuplicateShopWindowDescription from './DuplicateShopWindowDescription';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import ButtonColorsEnum from '../../../Enums/ButtonColorsEnum';

export default class ApolloShopCopierAdmin extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);

    this.state = {
      itemlist: [],
      loading: true,
      selected: -1,
      selectedItem: null,
      orderBy: 'Id',
      orderDirection: OrderDirectionsEnum.Desc,
      pageNumber: 1,
      numberOfElementsOnAPage: 20,
      numberOfElementsInTheTable: 0,
      shownPanel: ApolloShopCopierSearchParams.isThereAnySearchParameter()
        ? ShownPanelsEnum.Search
        : ShownPanelsEnum.None,
      searchItem: new ApolloShopCopierSearchParams(),
    };
    this.showPanel = this.showPanel.bind(this);
    this.escFunction = this.escFunction.bind(this);
    this.startSearch = this.startSearch.bind(this);
    this.editPanelOnClose = this.editPanelOnClose.bind(this);
  }

  componentDidMount() {
    document.addEventListener('keydown', this.escFunction, false);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.escFunction, false);
  }

  clickOnEditIcon(selectedId, selectedItem) {
    this.setState({
      selectedItem: selectedItem,
      shownPanel: ShownPanelsEnum.EditItem,
    });
  }

  startSearch(searchItem) {
    this.setState({
      loading: true,
      searchItem: searchItem,
    });
  }

  escFunction(event) {
    if (event.keyCode === 27) {
      this.setState({
        shownPanel: ShownPanelsEnum.None,
        selected: -1,
        selectedItem: null,
      });
    }
  }

  showPanel(panelId) {
    if (panelId === ShownPanelsEnum.Refresh) {
      this.refresh();
      panelId = ShownPanelsEnum.None;
    }
    panelId = panelId === this.state.shownPanel ? ShownPanelsEnum.None : panelId;
    this.setState({ shownPanel: panelId });
  }

  renderOnePanel(panelId, content) {
    return this.state.shownPanel === panelId ? content : null;
  }

  editPanelOnClose(refresh) {
    this.setState({
      shownPanel: ShownPanelsEnum.None,
    });
    if (refresh) {
      this.refresh();
    }
  }

  refresh() {
    this.setState({ searchItem: { ...this.state.searchItem } });
  }

  renderPanels() {
    return (
      <div>
        {this.renderOnePanel(
          ShownPanelsEnum.AddNewItem,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Create}
            editedItem={new DuplicateShopItem()}
            clickOnCancel={() => this.editPanelOnClose(false)}
            clickOnSave={() => this.editPanelOnClose(true)}
            windowDescription={DuplicateShopWindowDescription}
            errorCode='ASCA109'
          />
        )}
      </div>
    );
  }

  renderSearchStrip() {
    return (
      <GeneralSearchStrip
        searchItem={this.state.searchItem}
        searchparamsType={ApolloShopCopierSearchParams}
        isRefreshDisabled={false}
        isFilterDisabled={false}
        clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
        clickOnOk={(shownPanel, searchItem) => {
          this.setState({
            loading: true,
            searchItem: searchItem,
          });
        }}
        clickOnRefresh={(shownPanel, searchItem) => {
          this.setState({
            loading: true,
            searchItem: searchItem,
          });
        }}
      />
    );
  }
  renderButtonsAndPanels() {
    return (
      <>
        <ButtonRow
          colors={[ButtonColorsEnum.Common]}
          labels={['Duplicate']}
          keys={[ShownPanelsEnum.AddNewItem]}
          icons={['fa-solid fa-plus-circle']}
          roles={['ApolloShopCopier']}
          value={this.state.shownPanel}
          onClick={this.showPanel}
        />
        {this.renderPanels()}
      </>
    );
  }

  render() {
    return (
      <div className='contentwrapper'>
        {this.renderButtonsAndPanels()}
        <TabOfDataTable
          type={ApolloShopCopierHistoryItem}
          shownPanel={this.state.shownPanel}
          serviceFunction={ApolloShopCopierService.GetListBySearching}
          convertDBItemsFunction={ApolloShopCopierService.ConvertDBItems}
          searchItem={this.state.searchItem}
          orderDirection={OrderDirectionsEnum.Desc}
          showSearchStrip={true}
          clickOnStartSearch={this.startSearch}
          searchParamsType={ApolloShopCopierSearchParams}
          errorCode='ASCA198'
        />
      </div>
    );
  }
}
